import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { getAllAnswers } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'

export default function DeclutterPlanPage() {
  const { t } = useTranslation()
  const allAnswers = getAllAnswers()
  const room = allAnswers.room?.answer_key

  const isPersonalized = room !== undefined

  const headingKey = isPersonalized
    ? 'pages.onboarding.v2.declutterPlan.personalized.heading'
    : 'pages.onboarding.v2.declutterPlan.general.heading'
  const textKey = isPersonalized
    ? 'pages.onboarding.v2.declutterPlan.personalized.text'
    : 'pages.onboarding.v2.declutterPlan.general.text'

  return (
    <FeedbackPage
      emoji="📝"
      heading={t(headingKey)}
      text={t(textKey)}
      onSubmit={() => {}}
    />
  )
}
